module.exports = __webpack_public_path__ + "img/comment_5.ca1b697b.png";